// extracted by mini-css-extract-plugin
export default {"wrap":"hw-z","fullWidth":"iw-z","searchPlacement":"jw-z","items":"kw-z","featureCss":"lw-z","disabled":"mw-z","imgCss":"nw-z"};